import axios from 'axios';

// Inscription
export const createAccount = async (userData) => {
    const response = await axios.post('/api/auth/create-account', userData);
    return response.data;
};

// Connexion
export const login = async (credentials) => {
    const response = await axios.post('/api/auth/login', credentials);
    return response.data;
};